import React, { useEffect, useState, } from 'react';
import { Typography, InputAdornment, TextField, } from '@mui/material';
// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
// import { useNavigate } from 'react-router-dom';
import catalogue_image from '../../User/assets/catalogue.svg';
// import Cartproduct from '../../User/components/Cart_product';
import no_orders from '../../User/assets/no-orders.svg';
// import Uploadeddesigns from '../../User/components/Uploaded_designs';
// import FilterListIcon from '@mui/icons-material/FilterList';
import instance from '../../Utils/api';
import CartOrders from './CartOrders';



const orderdetails = [
  {
    "productName": "Trousers",
    "productDescription": "Lorem Ipsum has been the industry's standard.",
    "productImage": catalogue_image,
  },
  // {
  //     "productName": "Blouses",
  //     "productDescription": "Lorem Ipsum has been the industry's standard.",
  //     "productImage": catalogue_image,
  // },
  // {
  //     "productName": "Shirts",
  //     "productDescription": "Lorem Ipsum has been the industry's standard.",
  //     "productImage": catalogue_image,
  // },
  // {
  //     "productName": "Jeans",
  //     "productDescription": "Lorem Ipsum has been the industry's standard.",
  //     "productImage": catalogue_image,
  // }
]
const Myorders = () => {
  // const navigate = useNavigate();
  // const [currentTabIndex, setCurrentTabIndex] = useState(0);//usestate for tab section


  // // Function to go to the tabs
  // const handleTabChange = (e, tabIndex) => {
  //   setCurrentTabIndex(tabIndex);
  // };

  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };


  // const getOrderDetails = async () => {
  //   try {
  //     const response = await instance.get(`/Order/Orders`, );
  //     // console.log(response?.data?.data);

  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  // useEffect(() => {
  //   getOrderDetails();
  // }, [])

  return (
    <React.Fragment>
      <section className='mycart' style={{ marginTop: "80px" }}>
        {/* <div className='mycart-title'> */}
          {/* <Button ><KeyboardBackspaceIcon />Back</Button> */}
     
       
          {/* <div className='myorder-title'>
            <div className='category-menu'>
              <Button id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={<FilterListIcon />}>
                Filters
              </Button>
              <div>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                  className='filter-options'
                >
                  <MenuItem>Ordered placed</MenuItem>
                  <MenuItem>No fabric</MenuItem>
                </Menu>
              </div>
            </div>
          </div> */}
        {/* </div> */}
        {/* <section className='mycar-tabs'>
          <div className='tabs-title'>
            <Tabs value={currentTabIndex} onChange={handleTabChange}>
              <Tab label='Catalogue order' />
              <Tab label='Pickup Order' />
            </Tabs>
          </div>
        </section> */}
        {/* {currentTabIndex === 0 && ( */}
        <React.Fragment>
          {orderdetails.length === 0 ? (
            <React.Fragment>
              <div className='cart-no-items'>
                <img src={no_orders} alt='no_orders' />
                <Typography>We encourage you to order our designs</Typography>
              </div>
            </React.Fragment>

          ) : (
            <React.Fragment>
              {orderdetails.map((order, index) => (
                <CartOrders
                  key={index}  // Always provide a unique key when mapping in React
                  orderimage={order.productImage}  // Mapping the product image
                  productName={order.productName}  // Mapping the product name
                  productDescription={order.productDescription}  // Mapping the product description
                />
              ))}
            </React.Fragment>
          )}
        </React.Fragment>
        {/* )} */}
        {/* {currentTabIndex === 1 && (
          <React.Fragment>
            <section className='pickup-order'>
              <Uploadeddesigns />
            </section>
          </React.Fragment>
        )} */}

      </section>
    </React.Fragment>
  )
}

export default Myorders;